module.exports = __webpack_public_path__ + "static/Zapfino-8d90ff03898bd6719478de01830cf098.woff";